module.exports = __webpack_public_path__ + "img/coaching_1-sm.74b86440.png";